import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// --- ステップアイコン ---
const StepIconRoot = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 30,
  height: 30,
  zIndex: 1,
  '& .circle': { width: 20, height: 20, borderRadius: '50%', backgroundColor: '#0A7CB7' },
  '& .completedIcon': { color: '#0A7CB7', fontSize: 25 }
}));

function StepIcon({ completed }) {
  return (
    <StepIconRoot>
      {completed ? <Check className="completedIcon" /> : <div className="circle" />}
    </StepIconRoot>
  );
}

// --- ステップ間バー ---
const StepConnectorLine = styled('div')(({ progress }) => ({
  flex: 1,
  height: 3,
  margin: '0 4px',
  borderRadius: 2,
  alignSelf: 'flex-start',
  marginTop: 12,
  background: `linear-gradient(to right, #0A7CB7 ${progress}%, #ccc ${progress}%)`
}));

// --- サブタスク取得 ---
const getSubTasks = (reportDetailList, type) => {
  switch (type) {
    case 'first': return [reportDetailList?.ft_checked_at, reportDetailList?.ft_reported_to_leader_at, reportDetailList?.ft_reported_at, reportDetailList?.ft_reported_to_internal_at];
    case 'initial': return [reportDetailList?.ir_created_at, reportDetailList?.ir_approved_at, reportDetailList?.ir_reported_at, reportDetailList?.ir_reported_to_internal_at];
    case 'primary': return [reportDetailList?.pi_created_at, reportDetailList?.pi_approved_at, reportDetailList?.pi_reported_at, reportDetailList?.pi_reported_to_internal_at];
    case 'secondary': return [reportDetailList?.si_created_at, reportDetailList?.si_approved_at, reportDetailList?.si_reported_at, reportDetailList?.si_reported_to_internal_at];
    default: return [];
  }
};

// --- ステップ進捗計算 ---
const calcTaskProgress = (reportDetailList, stepName) => {
  let tasks = [];
  if (stepName === '初動対応') tasks = getSubTasks(reportDetailList, 'first');
  else if (stepName === '第1報') tasks = getSubTasks(reportDetailList, 'initial');
  else if (stepName === '１次点検') tasks = getSubTasks(reportDetailList, 'primary');
  else if (stepName === '２次点検' || stepName === '完了') tasks = getSubTasks(reportDetailList, 'secondary');

  if (stepName === '初動対応') {
    if (tasks[2] && tasks[3]) return 100;
  }

  if (!tasks.length) return 0;
  return Math.min(tasks.filter(Boolean).length * 25, 100);
};

// --- メインコンポーネント ---
export default function DamReportStepper({ reportDetailList, maxWidth = 700, paddingX = 0 }) {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    const stepNames = ['初動対応', '第1報', '１次点検', '２次点検', '完了'];
    setSteps(stepNames.map((name, idx) => ({ uuid: `step-${idx}`, name })));
  }, []);

  const taskProgresses = steps.map(s => calcTaskProgress(reportDetailList, s.name));

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          maxWidth,
          px: paddingX,
          boxSizing: 'border-box'
        }}
      >
        {steps.map((step, idx) => (
          <React.Fragment key={step.uuid}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <StepIcon completed={taskProgresses[idx] === 100} />
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' }
                }}
              >
                {step.name}
              </Typography>
            </Box>
            {idx < steps.length - 1 && (
              <StepConnectorLine progress={taskProgresses[idx]} />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
}